import { render, staticRenderFns } from "./veziharta.vue?vue&type=template&id=3e649efd&"
import script from "./veziharta.vue?vue&type=script&lang=js&"
export * from "./veziharta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports